<template>
  <div class="border" v-if="item">
    <h2>{{ item.name }}</h2>
    <hr />
    <div class="mt-4 ql-container ql-snow" style="border:none">
      <div class="ql-editor" v-html="item.description"></div>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "infos",
    cardSetLink: "infos",
    item: null,
    fields: [],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
